import React, { Component } from 'react';
import { ControlLabel, FormControl, Glyphicon, Checkbox, FormGroup, Well, Button } from 'react-bootstrap';
import { CCOAlert, CCOButton } from '../util/Components.js';
import { push, update, get, setSubState } from '../util/Utility.js';

export default class ManageMinistry extends Component {

  constructor(props) {
    super(props);

    this.state = {
      ministry: "new",
      ministries: null,
      deleteAlert: false,
      networkAlert: false,
      newMinistry: {
        name: "",
        leader: Object.keys(window.leaderNameStash)[0],
        type: "bible"
      }
    };

    get("ministries", this, null, (item) => { return !item.archived }, false).then(ministries => {
      this.setState({ministries});
    });

    // get("leaders", this).then(leaders => {
    //   this.setState({leaders});
    // });
  }

  save() {

    if (this.state.ministry === "new") {
      push('ministries', this, this.state.newMinistry).then(newObj => {
        let ministries = this.state.ministries;
        ministries[newObj.key] = newObj;
        let newMinistry = {
          name: "",
          leader: Object.keys(window.leaderNameStash)[0],
          type: "bible"
        }
        this.setState({ministries, newMinistry});
      }).catch(() => {
        this.setState({networkAlert: true});
      });


    } else {
      let ministry = this.state.ministries[this.state.ministry];

      update('ministries/' + this.state.ministry, this, ministry).then(() => {
        this.setState({saved: true});
        setTimeout(() => {
          this.setState({saved: false});
        }, 3000);
      }).catch(() => {
        this.setState({networkAlert: true});
      });
    }
  }

  delete() {
    if (!this.state.deleteAlert) {
      this.setState({deleteAlert: true});
    } else {
      update('ministries/' + this.state.ministry, this, {archived: true}).then(() => {

        let ministries = this.state.ministries;
        delete ministries[this.state.ministry];

        this.setState({ministry: "new", ministries, deleteAlert: false});
      }).catch(error => {
        console.warn(error);
        this.setState({networkAlert: true});
      });
    }
  }

  cancelDelete() {
    this.setState({deleteAlert: false});
  }

  render() {

    if (this.state.ministry === null || this.state.ministries === null) { return (<div />); }

    console.log(this.state.ministries);

    var ministryOptions = this.state.ministries ? Object.keys(this.state.ministries).sort((a, b) => {
      let aName = this.state.ministries[a].name, bName = this.state.ministries[b].name;
      if(aName < bName) return -1;
      if(aName > bName) return 1;
      return 0;
    }).map(item => { return <option key={item} value={item}>{this.state.ministries[item].name}</option>}) : null;
    ministryOptions.splice(0, 0, <option key="new" value="new">New Ministry</option>);

    let ministry = (this.state.ministry === "new") ? this.state.newMinistry : this.state.ministries[this.state.ministry];

    console.log(ministry);

    return (

      <center>
        <div style={{maxWidth: 350, padding: 10, textAlign: 'left'}}>
          <FormGroup key="group" controlId="group">
            <ControlLabel>Select Ministry</ControlLabel>
            <FormControl componentClass="select" value={this.state.ministry} onChange={(e) => {
              console.log(e.target.value);
              this.setState({ministry: e.target.value});
            }}>
              {ministryOptions}
            </FormControl>
          </FormGroup>

          <div style={{height: 15}} />

          <Well>
            <FormGroup controlId="Name">
              <ControlLabel color="black">Name</ControlLabel>
              <FormControl type="text" onChange={(e) => {
                if (this.state.ministry === "new") {
                  let newMinistry = this.state.newMinistry;
                  newMinistry.name = e.target.value;
                  this.setState({newMinistry});
                } else {
                  let ministries = this.state.ministries;
                  ministries[this.state.ministry].name = e.target.value;
                  this.setState({ministries});
                }
              }} value={ministry.name} />
            </FormGroup>

            <FormGroup key="leader" controlId="leader">
              <ControlLabel>Leaders</ControlLabel>
              {ministry.leaders && <table style={{width: '100%', marginBottom: 10}}>
                <tbody>
                  {ministry.leaders.map((leader, i) =>
                    <tr key={leader} style={{width: '100%',  height: 40}}>
                      <td style={{width: '99%'}}>{window.leaderNameStash[leader]}</td>
                      <td><Button bsStyle="danger" style={{align: 'right'}} onClick={() => {
                        if (this.state.ministry === "new") {
                          let leaders = this.state.newMinistry.leaders;
                          leaders.splice(i, 1);
                          setSubState(this, 'newMinistry', 'leaders', leaders);
                        } else {
                          let ministries = this.state.ministries;
                          ministries[this.state.ministry].leaders.splice(i, 1);
                          this.setState({ministries});
                        }
                      }}><Glyphicon glyph="trash" /></Button></td>
                    </tr>
                  )}
                </tbody>
              </table>}
              <FormControl componentClass="select" value="new" onChange={(e) => {
                if (this.state.ministry === "new") {
                  let leaders = this.state.newMinistry.leaders;
                  if (leaders)
                    leaders.push(e.target.value);
                  else
                    leaders = [e.target.value];
                  setSubState(this, 'newMinistry', 'leaders', leaders);
                } else {
                  let ministries = this.state.ministries;
                  if (ministries[this.state.ministry].leaders)
                    ministries[this.state.ministry].leaders.push(e.target.value);
                  else
                    ministries[this.state.ministry].leaders = [e.target.value];
                  this.setState({ministries});
                }
              }}>
                <option key="new" value="new">Add New Leader...</option>
                {Object.keys(window.leaderNameStash).sort((a, b) => {
                  let aName = window.leaderNameStash[a], bName = window.leaderNameStash[b];
                  if(aName < bName) return -1;
                  if(aName > bName) return 1;
                  return 0;
                }).filter(leader => !ministry.leaders || ministry.leaders.indexOf(leader) === -1).map(item => { return <option key={item} value={item}>{window.leaderNameStash[item]}</option>})}
              </FormControl>
            </FormGroup>

            <FormGroup key="type" controlId="type">
              <ControlLabel>Type</ControlLabel>
              <FormControl componentClass="select" value={ministry.type} onChange={e => {
                if (this.state.ministry === "new") {
                  setSubState(this, 'newMinistry', 'type', e.target.value);
                } else {
                  let ministries = this.state.ministries;
                  ministries[this.state.ministry].type = e.target.value;
                  this.setState({ministries});
                }
              }}>
                <option key="bible" value="bible">Bible Study</option>
                <option key="outreach" value="outreach">Outreach Ministry</option>
                <option key="service" value="service">Service Ministry</option>
              </FormControl>
              <Checkbox style={{marginTop: 3, marginLeft: 10}} checked={ministry.youth} onChange={() => {
                if (this.state.ministry === "new") {
                  setSubState(this, 'newMinistry', 'youth', this.state.newMinistry.youth ? false : true);
                } else {
                  let ministries = this.state.ministries;
                  ministries[this.state.ministry].youth = ministries[this.state.ministry].youth ? false : true;
                  this.setState({ministries});
                }
              }}>This is a Youth Ministry</Checkbox>
            </FormGroup>
            <Checkbox style={{marginTop: 3, marginLeft: 10}} checked={ministry.hide} onChange={() => {
              if (this.state.ministry === "new") {
                setSubState(this, 'newMinistry', 'hide', !ministry.hide);
              } else {
                let ministries = this.state.ministries;
                ministries[this.state.ministry].hide = !ministries[this.state.ministry].hide;
                this.setState({ministries});
              }
            }}>Hide Ministry from App</Checkbox>

            <center><CCOAlert in={this.state.networkAlert} type="danger" title="Network Error" content="Could not save because we could not connect to the server, please try again later." />

              <CCOButton onClick={this.save.bind(this)} text={this.state.ministry === "new" ? "Create Ministry" : "Save Changes"} type="primary" />

              {this.state.ministry !== "new" &&
          <div>
            <div style={{height: 10}} />
            <CCOButton type="destructive" text={this.state.deleteAlert ? "Confirm Delete" : "Delete Ministry"} onClick={this.delete.bind(this)} />
            <div style={{height: 5}} />
            {this.state.deleteAlert && <CCOButton type="primary" text="Cancel" onClick={this.cancelDelete.bind(this)} />}
            <div style={{height: 5}} />
            <CCOAlert in={this.state.deleteAlert} type="danger" title="Click Again to Delete" content={"Note that once deleted, this ministry cannot be recovered."} />
          </div>}
              <CCOAlert in={this.state.saved} type="success" title="Saved" content="Your changes were saved successfully" />
            </center>

          </Well>
        </div>
      </center>

    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/ministry/ManageMinistry.js
 **/